/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type PdpSharedPromoCode_displayInfo = {
    readonly pricing: {
        readonly showSale: boolean | null;
        readonly showNet: boolean | null;
    } | null;
    readonly " $refType": "PdpSharedPromoCode_displayInfo";
};
export type PdpSharedPromoCode_displayInfo$data = PdpSharedPromoCode_displayInfo;
export type PdpSharedPromoCode_displayInfo$key = {
    readonly " $data"?: PdpSharedPromoCode_displayInfo$data;
    readonly " $fragmentRefs": FragmentRefs<"PdpSharedPromoCode_displayInfo">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "PdpSharedPromoCode_displayInfo",
  "type": "ItemDisplayInfo",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "pricing",
      "storageKey": null,
      "args": null,
      "concreteType": "PriceInfoDisplay",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "showSale",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "showNet",
          "args": null,
          "storageKey": null
        }
      ]
    }
  ]
};
(node as any).hash = 'e9794f3d1b7d5470b139290c49f7b040';
export default node;
